import { getRgObjectsOfType as e, RG_TYPE as i } from "@project-rouge/rg-core";
import { getFootprint as n } from "./index21.js";
import { getArea as g } from "../index3.js";
const s = (t) => {
  const o = e(t, i.Building), r = n(o);
  return g(t) - r;
};
export {
  s as getNetArea
};
//# sourceMappingURL=index37.js.map
